import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ensureSceneTextFontsLoaded } from "@chuzi/shared/config";
import { App } from "./App";
import { loadRuntimeRealmLexiconOverrides } from "./lib/realm";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("chuzi-web: missing #root element in index.html");
}

loadRuntimeRealmLexiconOverrides();
ensureSceneTextFontsLoaded();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
